<template>
    <div>
        <a-crm-container>
            <template>
                <div class='a-crm-content'>
                    <div class='a-crm-tabs' v-if='$feature("cabinet_v2")'>
                        <span class='a-crm-tabs-item' :class='{"active": !isV2}' @click='setTab(false)'>{{ $t("crm.my_orders") }}</span>
                        <span class='a-crm-tabs-item' :class='{"active": isV2}' @click='setTab(true)'>{{ $t("crm.my_orders_v2") }}</span>
                    </div>
                    <div class='a-crm-content-box'>
                        <div>
                            <div class='a-crm-content-group'>
                                <p class='a-sub-heading a-crm-content-title'>{{ $t("crm.filter") }}</p>

                                <div class="row">
                                    <div class="col-6">
                                        <v-text-field
                                            :label='$t("crm.order_number")'
                                            :placeholder='$t("crm.order_number_placeholder")'
                                            v-model="form.number"
                                        />
                                    </div>
                                    <div class="col-6">
                                        <v-text-field
                                            :label='$t("crm.customer")'
                                            :placeholder='$t("crm.last_name_placeholder")'
                                            v-model="form.surname"
                                        />
                                    </div>
                                </div>

                            </div>
                            <div class='a-crm-content-group'>
                                <div class="row">
                                    <div class="col-4">
                                        <a-autocomplete
                                            :label='$t("crm.country_of_destination")'
                                            :placeholder='$t("crm.enter_the_country")'
                                            v-model='form.country'
                                            :requestName='getAutocompleteCountries'
                                            small
                                            item-value='code'
                                            return-object
                                            actionInitial
                                            initialLoading
                                            append-icon='arrow-down'
                                        />
                                    </div>
                                    <div class="col-4">
                                        <a-select
                                            :label='$t("crm.order_type")'
                                            :placeholder='$t("crm.not_selected")'
                                            :options='types'
                                            v-model="form.type"
                                            item-value="code"
                                            xsmall
                                        />
                                    </div>
                                    <div class="col-4">
                                        <a-select
                                            :label='$t("crm.booking_status")'
                                            :placeholder='$t("crm.not_selected")'
                                            :options='statuses'
                                            v-model="form.status"
                                            item-value="code"
                                            xsmall
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class='a-crm-content-group'>
                                <div class="row">
                                    <div class="col-6 col-md-6">
                                        <div class="row a-crm-content-date-row">
                                            <div class="col-6 a-crm-content-date-col">
                                                <div class='a-crm-content-date'>
                                                    <p class='app-label'>{{ $t("crm.date_of_arrival_from") }}:</p>
                                                    <date-picker
                                                        valueType="format"
                                                        v-model="form.dateFrom"
                                                        :placeholder='$t("crm.date")'
                                                        :lang="$i18n.locale"
                                                        class='mx-datepicker-small'
                                                        format="YYYY-MM-DD"
                                                        :disabled-date="date => date <= new Date().setHours(0, 0, 0, 0)"
                                                        :append-to-body='false'
                                                        :editable='false'
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-6 a-crm-content-date-col">
                                                <div class='a-crm-content-date'>
                                                    <p class='app-label'>{{ $t("crm.date_of_arrival_on") }}:</p>
                                                    <date-picker
                                                        valueType="format"
                                                        v-model="form.dateTo"
                                                        :placeholder='$t("crm.date")'
                                                        :lang="$i18n.locale"
                                                        class='mx-datepicker-small'
                                                        format="YYYY-MM-DD"
                                                        :disabled-date="date => date <= new Date().setHours(0, 0, 0, 0)"
                                                        :append-to-body='false'
                                                        :editable='false'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-6">
                                        <div class="row a-crm-content-date-row">
                                            <div class="col-6 a-crm-content-date-col">
                                                <div class='a-crm-content-date'>
                                                    <p class='app-label'>{{ $t("crm.date_of_booking_from") }}:</p>
                                                    <date-picker
                                                        valueType="format"
                                                        v-model="form.dateFromBooking"
                                                        :placeholder='$t("crm.date")'
                                                        :lang="$i18n.locale"
                                                        class='mx-datepicker-small'
                                                        format="YYYY-MM-DD"
                                                        :disabled-date="date => date <= new Date().setHours(0, 0, 0, 0)"
                                                        :append-to-body='false'
                                                        :editable='false'
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-6 a-crm-content-date-col">
                                                <div class='a-crm-content-date'>
                                                    <p class='app-label'>{{ $t("crm.date_of_booking_on") }}:</p>
                                                    <date-picker
                                                        valueType="format"
                                                        v-model="form.dateToBooking"
                                                        :placeholder='$t("crm.date")'
                                                        :lang="$i18n.locale"
                                                        class='mx-datepicker-small mx-datepicker-right'
                                                        format="YYYY-MM-DD"
                                                        :disabled-date="date => date <= new Date().setHours(0, 0, 0, 0)"
                                                        :append-to-body='false'
                                                        :editable='false'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class='a-crm-content-group-buttons'>
                            <v-button @click="filterOrder"
                                      xxsmall
                                      color="green-persian white--text">{{ $t("account.buttons.find") }}
                            </v-button>
                        </div>
                    </div>

                    <div class="a-crm-data-table-my-orders-preloader" v-if='loading'>
                        <div>
                            <div class='a-crm-data-table-my-orders-preloader-icon'>
                                <span v-html="require(`!html-loader!@/assets/baggage.svg`)"/>
                            </div>
                        </div>
                    </div>
                    <div class="a-crm-data-table-my-orders-preloader" v-else-if='isV2 && error'>
                        <div>
                            <p class='a-crm-data-table-my-orders-preloader-title'>{{ $t("crm.v2_unavailable") }}</p>
                        </div>
                    </div>
                    <div class="a-crm-data-table-my-orders-preloader" v-else-if='isV2 && !items.length'>
                        <div>
                            <div class='a-crm-data-table-my-orders-preloader-icon'>
                                <span v-html="require(`!html-loader!@/assets/baggage.svg`)"/>
                            </div>
                            <p class='a-crm-data-table-my-orders-preloader-title'>{{ $t("crm.v2_no_orders") }}</p>
                        </div>
                    </div>
                    <a-data-table
                        :headers='headers'
                        :items='orders'
                        :v2='isV2'
                        @action-row='viewCard($event)'
                        :isAction='true'
                        class='a-crm-data-table-my-orders'
                        v-else
                    />
                </div>
            </template>
        </a-crm-container>
    </div>
</template>

<script>
import ACrmContainer from '@/views/crm/container';
import ADataTable from '@/views/crm/order-data-table';
import {i18n} from '@/plugins/i18n';
import {cabinet, getAutocompleteCountries, getAutocompleteCRMStatuses} from '@/services/request';
import {getAutocompleteCRMTypes} from "../../services/request";

export default {
    data: () => ({
        form: {
            number: null,
            surname: null,
            type: null,
            status: null,
            country: null,
            dateFrom: null,
            dateTo: null,
            dateFromBooking: null,
            dateToBooking: null,
        },
        statuses: [{code: null, name: i18n.t('crm.not_selected')}],
        types: [{code: null, name: i18n.t('crm.not_selected')}],
        items: [],
        orders: [],
        loading: false,
        error: false
    }),
    computed: {
        isV2() {
            // Флаг обязателен: иначе раздел открывался бы через ?crm=v2 в адресе.
            return this.$feature('cabinet_v2') && this.$route.query.crm === 'v2'
        },
        headers() {
            const headers = [
                {text: i18n.t("crm.number"), value: 'number', color: '#ffffff', BgColor: '#00B796'},
                {text: i18n.t("crm.booking_status"), value: 'crmStatus'},
                {text: i18n.t("crm.tourist"), value: 'tourist'},
                {text: i18n.t("crm.country"), value: 'countryName'},
                // {text: i18n.t("crm.balance"), value: 'balance'},
                {text: i18n.t("crm.price"), value: 'price'},
                {text: i18n.t("crm.created_at"), value: 'createdAt'}
            ];

            if (this.isV2) {
                headers.splice(2, 0, {text: i18n.t("crm.payment_status"), value: 'crmPaymentStatus'});
            }

            return headers
        },
    },
    components: {
        ACrmContainer,
        ADataTable
    },
    mounted() {
        this.getStatuses();
        this.getTypes();
        this.getItems();
    },
    watch: {
        isV2() {
            this.getItems();
        }
    },
    methods: {
        getAutocompleteCountries,
        setTab(v2) {
            if (v2 === this.isV2) return;
            const query = {...this.$route.query};
            if (v2) {
                query.crm = 'v2';
            } else {
                delete query.crm;
            }
            this.$router.push({query});
        },
        viewCard($event) {
            this.$router.push({
                name: "my-order",
                // v2 открывается по id новой CRM: crmOrderId — это номер OneBox,
                // у заказов, родившихся в CRM v2, он пустой.
                params: {id: this.isV2 ? $event.crmV2OrderId : $event.number, lang: this.$route.params.lang},
                query: this.isV2 ? {crm: 'v2'} : undefined
            })
        },
        getItems() {
            this.loading = true;
            this.error = false;
            const v2 = this.isV2;
            (v2 ? cabinet.orderV2.index() : cabinet.order.index()).then(r => {
                if (v2 !== this.isV2) return;
                this.items = r.data;
                this.filterOrder();
            }).catch(() => {
                if (v2 !== this.isV2) return;
                this.items = [];
                this.orders = [];
                this.error = true;
            }).finally(() => this.loading = false);
        },
        getStatuses() {
            getAutocompleteCRMStatuses().then(r => {
                this.statuses = this.statuses.concat(r.data);
            });
        },
        getTypes() {
            getAutocompleteCRMTypes().then(r => {
                this.types = this.types.concat(r.data);
            });
        },
        filterOrder() {
            this.orders = [];
            this.items.forEach(item => {
                if (this.form.number) {
                    if (this.form.number != item.number) return;
                }

                if (this.form.surname) {
                    if (item.surname.indexOf(this.form.surname) === -1) return;
                }

                if (this.form.type) {
                    if (this.form.type !== item.crmType.code) return;
                }

                if (this.form.status) {
                    if (this.form.status !== item.crmStatus.code) return;
                }

                if (this.form.country) {
                    if (this.form.country !== item.countryCode) return;
                }

                if (this.form.dateFrom) {
                    if (item.dateFrom <= this.form.dateFrom) return;
                }

                if (this.form.dateTo) {
                    if (item.dateTo >= this.form.dateTo) return;
                }

                if (this.form.dateFromBooking) {
                    if (item.dateBooking <= this.form.dateFromBooking) return;
                }

                if (this.form.dateToBooking) {
                    if (item.dateBooking >= this.form.dateToBooking) return;
                }


                let order = Object.assign({
                    price: this.$helpers.amount(item.amount, 'EUR'),
                    balance: this.$helpers.amount(0, 'EUR')
                }, item, {
                    created: item.createdAt ? this.$moment(item.createdAt).format('DD.MM.YY HH:mm') : ''
                })

                this.orders.push(order);
            });
        }
    }
}
</script>

<style lang="scss">
@import "@/styles/global/variables";
@import "@/styles/global/mixins";

.a-crm-tabs {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    &-item {
        font-size: 14px;
        font-weight: 400;
        color: rgba($black, .6);
        border: 1px solid rgba($black, .15);
        border-radius: 10px;
        padding: 8px 16px;
        cursor: pointer;
        transition: color $transition, border-color $transition;

        &:hover,
        &.active {
            color: $green-persian;
            border-color: $green-persian;
        }

        &:not(:last-child) {
            margin-right: 10px;
        }
    }
}

.a-crm-data-table-my-orders {
    margin-top: 50px;

    td {
        min-width: 150px;
    }

    &-preloader {
        padding: 50px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        @include minw($grid-breakpoints-xs) {
            height: calc(100% - 50px * 2);
        }

        &-icon {
            width: 125px;
            height: 132px;
            margin: auto;
            margin-bottom: 30px;
            @include minw($grid-breakpoints-xs) {
                width: 201px;
                height: 213px;
                margin-bottom: 40px;
            }
        }

        &-title {
            font-size: 25px;
            font-weight: 700;
            margin-bottom: 16px;
            @include minw($grid-breakpoints-xs) {
                font-size: 20px;
            }
        }

        &-text {
            font-size: 14px;
            font-weight: 400;
            @include minw($grid-breakpoints-xs) {
                font-size: 16px;
            }
        }
    }
}
</style>
